/* lkp2-12.js - Lush Keepsake personaliser v2, part 12 of 16 (readable source: build/src/lkp2.js; split by build/minify.py) */
(function(){'use strict';var K=window.__lkp2k=window.__lkp2k||{};
var D=K.D,DASH=K.DASH,EN=K.EN,SEP_RE=K.SEP_RE,POUND_FMT=K.POUND_FMT,EMAIL=K.EMAIL,BLANK_DEFAULT=K.BLANK_DEFAULT,NUM_WORDS=K.NUM_WORDS,SWATCH=K.SWATCH,INK_DARK=K.INK_DARK,INK_LIGHT=K.INK_LIGHT,CAP=K.CAP,esc=K.esc,h=K.h,clamp=K.clamp,clone=K.clone,lc=K.lc,isObj=K.isObj,merge=K.merge,firstInt=K.firstInt,money=K.money,hash=K.hash,debounce=K.debounce,cleanLabel=K.cleanLabel,fontByN=K.fontByN,swatchFor=K.swatchFor,inkFor=K.inkFor,CFG=K.CFG,loadConfig=K.loadConfig,IMG=K.IMG,loadImg=K.loadImg,ART_INK=K.ART_INK,ARTTXT=K.ARTTXT,artBaseUrl=K.artBaseUrl,artText=K.artText,artRaster=K.artRaster,MOTIF=K.MOTIF,motifImg=K.motifImg,MAPS=K.MAPS,mapNorm=K.mapNorm,mapDist=K.mapDist,mapJson=K.mapJson,mapFind=K.mapFind,mapPlace=K.mapPlace,ICONIMG=K.ICONIMG,iconSvg=K.iconSvg,iconImg=K.iconImg,FONTREADY=K.FONTREADY,fontReady=K.fontReady,QR=K.QR,loadQR=K.loadQR,cleanRegion=K.cleanRegion,LEGACY=K.LEGACY,fallbackConfig=K.fallbackConfig,lineFields=K.lineFields,P=K.P,MORSE=K.MORSE,pathPts=K.pathPts,polyLen=K.polyLen,visRun=K.visRun,drawPathText=K.drawPathText,toMorse=K.toMorse,subMax=K.subMax,subKey=K.subKey,propKey=K.propKey,faceKey=K.faceKey,textKey=K.textKey,optText=K.optText,propVal=K.propVal,fmtDate=K.fmtDate,fmtTime=K.fmtTime,drawPlaceholder=K.drawPlaceholder,drawClock=K.drawClock,drawCalendar=K.drawCalendar,drawSpotify=K.drawSpotify,drawQR=K.drawQR,NOISE=K.NOISE,noisePattern=K.noisePattern,autoTone=K.autoTone,shade=K.shade,drawPlate=K.drawPlate,residual=K.residual,METAL=K.METAL;
P.prototype.togglePick = function (id) {
var ci = this.countInfo(); if (!ci) return;
var p = this.st.picked || [], i = p.indexOf(id);
if (i >= 0) { if (p.length > (ci.n ? ci.n : ci.min)) p.splice(i, 1); else if (ci.n) { this.flash(ci.n === 1 ? 'Choose a different ' + this.units(1) + ' by ticking it - your option includes 1.' : 'Your option includes ' + ci.n + ' ' + this.units(2) + '. Tick another one first, then untick this one.'); return; } else { this.flash('At least one ' + this.units(1) + ' is needed.'); return; } }
else {
if (ci.n && p.length >= ci.n) {
if (ci.n === 1) p = []; else { this.flash('Your option includes ' + ci.n + ' ' + this.units(2) + ' - untick one first, or choose a bigger option above.'); return; }
}
p.push(id);
}
var order = ci.counted.map(function (f) { return f.id; });
p.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
this.st.picked = p;
if (p.indexOf(id) >= 0) this.st.active = id;
this.sync();
};
P.prototype.flash = function (msg) {
var el = this.elPick.querySelector('[data-pickmsg]'); if (!el) return;
el.textContent = msg; el.hidden = false; clearTimeout(this._ft); this._ft = setTimeout(function () { el.hidden = true; }, 4500);
};
P.prototype.clearFace = function (id) {
var f = this.face(id); if (!f) return;
delete this.st.vals[id]; this.st.same[id] = false; delete this.st.files[id];
var me = this; Object.keys(this.st.touched).forEach(function (k) { if (k.indexOf(id + ':') === 0) delete me.st.touched[k]; });
this.renderPanel(id); // the open panel must not keep the removed wording in its inputs
var ci = this.countInfo();
if (ci && ci.pick && !ci.n && this.st.picked && this.st.picked.length > ci.min) this.st.picked = this.st.picked.filter(function (x) { return x !== id; });
this.sync();
};
P.prototype.sync = function (first) {
var me = this, faces = this.faces(), blank = !this.choices && this.isBlank();
var col = this.colour();
this.root.querySelectorAll('[data-yn]').forEach(function (b) { b.setAttribute('aria-pressed', String((b.getAttribute('data-yn') === '1') === me.st.engrave)); b.disabled = blank; });
var bm = this.root.querySelector('[data-blankmsg]');
bm.hidden = !(blank || !this.st.engrave);
bm.textContent = blank ? 'You have chosen the plain option, so nothing will be added. Choose a different option above to personalise it.' : 'We will send it plain, with no ' + (this.verb().made === 'engraving' ? 'engraving' : 'personalisation') + '.';
var yn = this.root.querySelector('.lkp2__yn'); if (yn) yn.hidden = blank;
var cw = this.root.querySelector('.lkp2__confwrap'); if (cw) cw.hidden = !faces.length;
var ok = this.root.querySelector('[data-act="ok"]'); if (ok) ok.textContent = faces.length ? (this.choices ? 'Confirm choices' : 'Confirm ' + (this.verb().made === 'engraving' ? 'engraving' : 'wording')) : 'Continue without ' + (this.verb().made === 'engraving' ? 'engraving' : 'personalisation');
this.elBody.hidden = !faces.length && (blank || !this.st.engrave) && !this.hasFinish(); // keep the Options step (gold type / engraving) visible on products whose default variant is plain
this.root.querySelectorAll('[data-col]').forEach(function (b) { b.setAttribute('aria-checked', String(lc(b.getAttribute('data-col')) === lc(col))); });
var cn = this.root.querySelector('[data-colname]'); if (cn) cn.textContent = col || 'please choose';
var ce = this.root.querySelector('[data-colerr]'); if (ce && col) ce.hidden = true;
var ci = this.countInfo();
if (ci && ci.pick && faces.length) {
this.elPick.hidden = false;
var html = '<p class="lkp2__label">' + (ci.n ? 'Which ' + (ci.n === 1 ? this.units(1) : ci.n + ' ' + this.units(2)) + ' should we ' + this.verb().act + '?' : 'Which ' + this.units(2) + ' should we ' + this.verb().act + '? <span class="lkp2__muted">(tick one or more)</span>') + '</p><div class="lkp2__chips">';
ci.counted.forEach(function (f) { var on = me.st.picked.indexOf(f.id) >= 0; html += '<button type="button" class="lkp2__chip" data-pickface="' + esc(f.id) + '" aria-pressed="' + on + '"><i aria-hidden="true"></i>' + esc(f.label) + '</button>'; });
html += '</div><p class="lkp2__hint" data-pickmsg hidden></p>';
this.elPick.innerHTML = html;
} else { this.elPick.hidden = true; this.elPick.innerHTML = ''; }
var sig = faces.map(function (f) { return f.id; }).join(',');
if (!faces.some(function (f) { return f.id === me.st.active; })) this.st.active = faces[0] ? faces[0].id : null;
if (sig !== this._sig) { this._sig = sig; this.renderPanels(); }
if (this.elGFont) this.renderGFont();
this.renderTabs();
this.renderSteps();
this.changed();
};
P.prototype.changed = function () {
var me = this;
this.updatePrice();
clearTimeout(this._ct);
this._ct = setTimeout(function () {
me.drawStage(); me.drawTabs(); me.renderSummary(); me.writeProps(); me.renderPageSum(); me.renderSteps();
if (me.st.showErrors) me.validate(false);
}, 40);
};
P.prototype.updatePrice = function () {
if (!this.variant) return;
var n = this.priceCount(), vb = this.verb(), any = this.faces().length;
var t = '<b>' + money(this.variant.p) + '</b> ' + (this.choices ? '' : any ? '<span>' + vb.inc + (n > 1 ? ' (' + n + ' ' + this.units(n) + ')' : '') + '</span>' : '<span>' + vb.none + '</span>');
[this.root, this.host].forEach(function (x) { var el = x && x.querySelector('[data-price]'); if (el) el.innerHTML = t; });
};
P.prototype.setActive = function (id, fromTab, openPanel) {
if (!id) return;
this.st.active = id;
if (this.st.zoom === 'full') this.st.zoom = 'face';
var me = this;
this.elPanels.querySelectorAll('.lkp2__panel').forEach(function (p) { var on = p.getAttribute('data-face') === id, ph = p.querySelector('.lkp2__phead'); p.classList.toggle('is-open', on); if (ph) ph.setAttribute('aria-expanded', String(on)); });
if (this.isModal()) { this.st.step = id; this.renderSteps(); fromTab = false; }
this.elTabs.querySelectorAll('[data-tab]').forEach(function (b) { b.setAttribute('aria-selected', String(b.getAttribute('data-tab') === id)); });
if (fromTab) { var p = this.panelEl(id); if (p && window.innerWidth >= 990) p.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); }
this.drawStage();
};
P.prototype.panelEl = function (id) { return this.elPanels.querySelector('.lkp2__panel[data-face="' + (window.CSS && CSS.escape ? CSS.escape(id) : id) + '"]'); };
P.prototype.renderTabs = function () {
var me = this, faces = this.faces();
this.elTabs.innerHTML = '';
this.elTabs.hidden = faces.length < 2;
faces.forEach(function (f) {
var b = h('button', { type: 'button', class: 'lkp2__tab', role: 'tab', 'data-tab': f.id, 'aria-selected': String(f.id === me.st.active) },
'<canvas width="132" height="99" aria-hidden="true"></canvas><span>' + esc(f.label) + '</span><i class="lkp2__tick" aria-hidden="true"></i>');
me.elTabs.appendChild(b);
});
};
P.prototype.drawTabs = function () {
var me = this;
if (this.isModal()) return; // the modal uses the step row; its stage shows the active side
clearTimeout(this._tt);
this._tt = setTimeout(function () {
me.faces().forEach(function (f) {
var b = me.elTabs.querySelector('[data-tab="' + f.id + '"]'); if (!b) return;
b.classList.toggle('is-done', me.hasContent(f));
b.classList.toggle('has-error', !!me.errs && !!me.errs[f.id]);
me.render(b.querySelector('canvas'), f, 'face');
});
}, 200);
};
P.prototype.drawStage = function () {
var me = this, f = this.face(this.st.active), cv = this.cv;
if (!f || !this.faces().length) return;
var dpr = Math.min(window.devicePixelRatio || 1, 2.5);
var w = Math.round(cv.clientWidth * dpr), hh = Math.round(cv.clientHeight * dpr);
if (w < 10 || hh < 10) return;
if (cv.width !== w || cv.height !== hh) { cv.width = w; cv.height = hh; }
var seq = ++this.drawSeq;
var spin = this.root.querySelector('[data-spin]'); spin.classList.add('is-on');
var zl = this.root.querySelector('[data-zoomlbl]'); if (zl) zl.textContent = this.st.zoom === 'close' ? 'Zoom out' : 'Zoom in';
var fb = this.root.querySelector('[data-full] span'); if (fb) fb.textContent = this.st.zoom === 'full' ? 'Close-up' : (this.cfg.art ? 'Whole item' : 'Whole photo');
var off = this._off || (this._off = document.createElement('canvas')); off.width = w; off.height = hh;
var blit = function () { if (seq !== me.drawSeq) return; var x = cv.getContext('2d'); x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, w, hh); x.drawImage(off, 0, 0); };
this.render(off, f, this.st.zoom, { dpr: dpr, after: blit, hl: this.isModal() }).then(function (plan) {
if (seq !== me.drawSeq) return;
blit();
spin.classList.remove('is-on');
me.root.querySelector('[data-facename]').textContent = f.label;
var note = me.root.querySelector('[data-stagenote]');
var msgs = [];
if (plan && plan.photo && plan.photo.isFallback && plan.photo.colour) msgs.push('Shown in ' + plan.photo.colour + ' - yours will be ' + me.colour() + '.');
var pv = plan && plan.photo;
var fb2 = me.root.querySelector('[data-full] span'); if (fb2 && pv && pv.isArt) fb2.textContent = me.st.zoom === 'full' ? 'Close-up' : 'Whole item';
if (pv && pv.fromDirty) msgs.push('Your wording on a plain plate - "Whole photo" shows the piece');
else if (pv && pv.dirty && plan.raw && me.drawable(f)) msgs.push('Photo shows an example - yours reads as typed below');
if (plan && plan.ghost && !plan.noExample && !msgs.length) msgs.push(me.isModal() ? 'Example - type to see yours' : 'Example - type below to see yours');
note.textContent = msgs.join(' '); note.hidden = !msgs.length;
var vb = me.root.querySelector('[data-view]');
var noZoom = !me.drawable(f) && !(pv && pv.hasZone);
me.root.querySelectorAll('[data-zoom],[data-full]').forEach(function (b) { b.hidden = noZoom; });
if (vb) { vb.hidden = !(pv && pv.count > 1); if (pv) vb.querySelector('span').textContent = 'Photo ' + ((pv.idx || 0) + 1) + '/' + pv.count; }
me.facePlanErr(f.id, plan && plan.err);
});
};
P.prototype.renderPanels = function () {
var me = this;
this.elPanels.innerHTML = '';
var faces = this.faces();
faces.forEach(function (f, i) {
var p = h('section', { class: 'lkp2__panel' + (f.id === me.st.active ? ' is-open' : ''), 'data-face': f.id });
if (me.isModal()) p.innerHTML = '<p class="lkp2__shead"><small data-sidx></small><b>' + esc(f.label) + (me.isOptional(f) ? ' <em>(optional)</em>' : '') + '</b></p><div class="lkp2__pbody"></div>';
else p.innerHTML = '<button type="button" class="lkp2__phead" data-open="' + esc(f.id) + '" aria-expanded="' + (f.id === me.st.active) + '">' +
'<span class="lkp2__pnum">' + (i + 1) + '</span><span class="lkp2__ptitle">' + esc(f.label) + (me.isOptional(f) ? ' <em>' + (f.optional ? '(optional)' : 'Optional - add another ' + me.units(1)) + '</em>' : '') + '<small data-psum></small></span>' +
'<svg class="lkp2__chev" viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button>' +
'<div class="lkp2__pbody"></div>';
me.elPanels.appendChild(p);
me.renderPanel(f.id);
});
};
P.prototype.renderPanel = function (id) {
var f = this.face(id), p = this.panelEl(id); if (!f || !p) return;
var me = this, body = p.querySelector('.lkp2__pbody'), V = this.vals(f), html = '';
var focusK = document.activeElement && body.contains(document.activeElement) ? document.activeElement.getAttribute('data-k') : null;
if (f.hint) html += '<p class="lkp2__hint">' + esc(f.hint) + '</p>';
if (f.sameAs) {
var other = this.face(f.sameAs);
if (other) html += '<label class="lkp2__same"><input type="checkbox" data-same data-face="' + esc(id) + '"' + (this.st.same[id] ? ' checked' : '') + '> Same as ' + esc(other.label) + '</label>';
}
if (f.sameAs && this.st.same[id]) { body.innerHTML = html; return; }
if (f.modes && f.modes.length > 1) {
var cur = this.modeOf(f);
html += '<div class="lkp2__seg" role="group" aria-label="What to engrave">' + f.modes.map(function (m) {
return '<button type="button" data-face="' + esc(id) + '" data-mode="' + esc(m.id) + '" aria-pressed="' + (m.id === cur.id) + '">' + esc(m.label) + '</button>';
}).join('') + '</div>';
}
this.fieldsOf(f).forEach(function (fd) { html += me.fieldHtml(f, fd, V); });
html += '<p class="lkp2__err" data-fiterr hidden></p>';
body.innerHTML = html;
body.querySelectorAll('.lkp2__hint').forEach(function (x) { x.title = x.textContent; });
var fs = this.st.files[id];
var slot = body.querySelector('[data-fileslot]');
if (slot) {
var inp = fs && fs.input;
if (!inp) { inp = h('input', { type: 'file', class: 'lkp2__file', 'data-upload': true, 'data-face': id, accept: 'image/*,.pdf,.heic', form: this.formId }); }
slot.appendChild(inp);
}
if (focusK) { var el = body.querySelector('[data-k="' + focusK + '"]'); if (el) { el.focus(); try { var L = el.value.length; el.setSelectionRange(L, L); } catch (e) {} } }
};
})();